import { render } from "./FormSelectedData.vue?vue&type=template&id=3bebaa88"
import script from "./FormSelectedData.vue?vue&type=script&lang=js"
export * from "./FormSelectedData.vue?vue&type=script&lang=js"

import "./FormSelectedData.vue?vue&type=style&index=0&id=3bebaa88&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__